import { t } from 'i18next';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CompletedFanBuddyCardPage = () => {
  const navigate = useNavigate();
  const currentQueryParams = new URLSearchParams(window.location.search);

  // 3초 후 화면 전환
  useEffect(() => {
    const timer = setTimeout(() => {
      navigateShowFanBuddyCard();
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const navigateShowFanBuddyCard = () => {
    const queryString = new URLSearchParams(currentQueryParams).toString();
    navigate(`/fan-buddy/show-fan-buddy-card?${queryString}`);
  };

  return (
    <div className="min-h-screen bg-white dark:bg-[#222222]">
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 px-6 w-full max-w-xl">
        <div className="flex flex-col items-center">
          <div className="w-[219px] h-[219px] flex items-end justify-center relative">
            <img src={'/assets/icons/collections/Milky Way.png'} alt="milkyway" />
            <img
              width={'172px'}
              height={'172px'}
              src={'/assets/backgrounds/fan-buddy/Mage Light Skin Tone.png'}
              alt={'wizard'}
              className="absolute bottom-1 left-1/2 -translate-x-1/2"
            />
          </div>
          <div className="flex flex-col mt-[22px] items-center gap-[14px]">
            <p className="text-main-light-1 dark:text-main-dark-1 text-[20px] font-semibold leading-[24px] text-center whitespace-pre-wrap">
              {t('CompletedFanBuddyCard.title')}
            </p>
            <p className="text-main-light-4 dark:text-main-dark-4 text-[15px] font-medium leading-[22px] text-center">
              {t('CompletedFanBuddyCard.description')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompletedFanBuddyCardPage;
